<script>
import has from "lodash/has";
import { Doughnut } from "vue-chartjs";
import Chart from "chart.js";

export default {
  extends: Doughnut,
  props: {
    data: Object,
    options: Object,
    centerText: String,
    centerSubText: String,
  },
  watch: {
    // ✅ WATCH for changes to centerText and centerSubText and force chart update
    centerText() {
      this.updateChart();
    },
    centerSubText() {
      this.updateChart();
    },
  },
  mounted() {
    let linearStroke = [0, 0, 0, 450];
    let backgroundColor = [];

    this.data.datasets.forEach((obj) => {
      if (has(obj, "gradientFill") && obj.gradientFill.length) {
        linearStroke = has(obj, "linearStroke") ? obj.linearStroke : linearStroke;
        const backgroundColor = [];
        obj.gradientFill.forEach((gradientSet) => {
          let gradientFill = this.$refs.canvas
            .getContext("2d")
            .createLinearGradient(...linearStroke);
          gradientSet.forEach((hex, index) => {
            if (typeof hex === "object" && has(hex, "stop") && has(hex, "color")) {
              let { stop, color } = hex;
              gradientFill.addColorStop(stop, color);
            } else {
              let stop = index > 0 ? 1 / index : 0;
              stop = Number(stop.toFixed(1));
              gradientFill.addColorStop(stop, hex);
            }
          });
          backgroundColor.push(gradientFill);
        });

        if (!has(obj, "backgroundColor")) {
          obj.backgroundColor = backgroundColor;
        }
      }
    });

    if (!has(this.data.datasets, "backgroundColor")) {
      this.data.datasets.backgroundColor = backgroundColor;
    }

    // ✅ Register the plugin ONCE (if not already registered)
    if (!Chart.plugins.getAll().some((plugin) => plugin.id === "doughnut-center-text")) {
      Chart.plugins.register({
        id: "doughnut-center-text",
        beforeDraw(chart) {
          if (chart.config.type !== "doughnut") return;

          const { centerText, centerSubText } = chart.options.plugins.doughnutCenterText || {};
          if (!centerText && !centerSubText) return;

          const ctx = chart.chart.ctx;
          const chartArea = chart.chartArea;
          ctx.save();

          // ✅ CLEAR the previous text (fix for multiple charts)
          ctx.clearRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

          const textX = (chartArea.left + chartArea.right) / 2;
          const textY = (chartArea.top + chartArea.bottom) / 2 - 10;

          ctx.font = "bold 24px Arial";
          ctx.fillStyle = "#00c853";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(centerText, textX, textY);

          if (centerSubText) {
            ctx.font = "16px Arial";
            ctx.fillStyle = "#FFF";
            ctx.fillText(centerSubText, textX, textY + 25);
          }

          ctx.restore();
        },
      });
    }

    // ✅ Ensure correct options
    const updatedOptions = {
      ...this.options,
      cutoutPercentage: 75,
      plugins: {
        doughnutCenterText: {
          centerText: this.centerText,
          centerSubText: this.centerSubText,
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          padding: 10, // ✅ Extra space between legend items
          boxWidth: 12, // ✅ Larger color boxes
          color: '#FFFFFF'
        },
      },
      layout: {
        padding: {
          top: 5,
          bottom: 20, // ✅ More space between chart & legend
        },
      },
    };

    // ✅ Render the chart
    this.renderChart(this.data, updatedOptions);
  },
  methods: {
    updateChart() {
      if (this.$data._chart) {
        this.$data._chart.options.plugins.doughnutCenterText = {
          centerText: this.centerText,
          centerSubText: this.centerSubText,
        };
        this.$data._chart.update(); // ✅ Forces a re-render with new text
      }
    },
  },
  beforeDestroy() {
    if (this.$data._chart) {
      this.$data._chart.destroy();
    }
  },
};

</script>
